module.exports = __webpack_public_path__ + "static/media/KNOW_TRICKS.2c6b93be.svg";